<template>
  <div class="student-rda-container">
    <div
      v-for="(item, index) in competencesWithoutModality"
      :key="`no-modality-${index}`"
    >
      <b-row class="rda-viewlist" style="padding-left: 0">
        <b-col cols="12" style="padding-left: 6px">
          <h4 class="title competence-details" v-if="item.details">
            {{ item.details }}
          </h4>
          <template v-if="item.TematicUnit && item.TematicUnit.description">
            <h4 class="title tematic-unit-title">
              {{ item.sort_order + " - " }}Unidade Temática:
              {{ item.TematicUnit.description }}
            </h4>
            <h5 class="title comp-description">
              Competência:
              {{ item.description }}
            </h5>
          </template>
          <template v-else>
            <h4 class="title comp-description">
              {{ item.sort_order + " - " }}Competência:
              {{ item.description }}
            </h4>
          </template>
        </b-col>
        <b-col
          cols="12"
          style="padding-left: 6px"
          v-for="(topic, indexS) in item.Topics"
          :key="`topic-${indexS}`"
        >
          <div class="list-teacher item-rda-viewlist">
            <div class="cols text-col">
              <template
                v-if="
                  topic.KnowledgeObject && topic.KnowledgeObject.description
                "
              >
                <p class="knowledge-object-title">
                  {{
                    `${item.sort_order}.${topic.sort_order} - `
                  }}Objeto de Conhecimento:
                  {{ topic.KnowledgeObject.description }}
                </p>
                <p class="topic-description">
                  Conteúdo: {{ topic.description }}
                </p>
              </template>
              <template v-else>
                <p class="topic-description">
                  {{
                    `${item.sort_order}.${topic.sort_order} `
                  }}Conteúdo: {{ topic.description }}
                </p>
              </template>

              <p
                v-if="
                  topic.TopicStudents.length > 0 &&
                  topic.TopicStudents[0].updated_at
                "
                class="topic-description"
                style="color: #939393"
              >
                <span
                  v-if="
                    topic.TopicStudents[0].editor &&
                    topic.TopicStudents[0].editor.name
                  "
                >
                  Atualizado por
                  <strong>{{ topic.TopicStudents[0].editor.name }}</strong>
                </span>
                <span v-else> Atualizado </span>
                em {{ formatDate(topic.TopicStudents[0].updated_at) }}
              </p>
            </div>
            <div
              class="cols"
              v-if="
                topic.TopicStudents[0].status === 'AN' &&
                topic.TopicStudents[0].pendency
              "
            >
              <b-button
                class="evidence-btn"
                @click="showEvidence(topic.TopicStudents[0].pendency)"
              >
                Pendência
              </b-button>
            </div>
            <div class="cols">
              <p
                class="tags"
                :style="{
                  backgroundColor: setStatusColor(
                    topic.TopicStudents[0].status
                  ),
                }"
              >
                {{ topic.TopicStudents[0].status }}
              </p>
            </div>
            <div class="cols"></div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div v-if="hasLanguageCompetences">
      <div
        class="mb-2"
        style="display: flex; align-items: center; padding-left: 20px"
      >
        <span
          style="
            display: inline-block;
            width: 18px;
            height: 18px;
            background: #28a745;
            border-radius: 4px;
            margin-right: 8px;
          "
        ></span>
        <span style="font-size: 15px; color: #495057">Níveis ativos</span>
      </div>
      <div
        v-for="(levelGroup, levelName) in groupedLanguagesByLevel"
        :key="`language-level-${levelName}`"
        class="level-group col-12"
      >
        <b-card-header
          header-tag="header"
          role="tab"
          :style="{
            border: '1px solid #dee2e6',
            borderRadius: '10px',
            cursor: 'pointer',
            borderLeft: !levelLanguageDisabled[levelName]
              ? '4px solid #28a745'
              : '1px solid #dee2e6',
          }"
          v-b-toggle="
            'accordion-language-level-' + getLevelId('language', levelName)
          "
          class="accordion-header"
        >
          <h5 style="color: #b23066">
            {{ levelName }}
          </h5>
        </b-card-header>

        <b-collapse
          :id="'accordion-language-level-' + getLevelId('language', levelName)"
          role="tabpanel"
        >
          <b-row
            v-for="item in levelGroup"
            :key="`language-competence-${item.id}`"
            class="rda-viewlist"
            style="padding-left: 0"
          >
            <b-col cols="12" style="padding-left: 6px">
              <h4
                class="title tematic-unit-title"
                v-if="item.TematicUnit && item.TematicUnit.description"
              >
                {{ item.sort_order + " - " }}Unidade
                Temática:
                {{ item.TematicUnit.description }}
              </h4>
              <h5 class="title comp-description">
                {{
                  !item.TematicUnit
                    ? item.sort_order + " "
                    : ""
                }}Competência:
                {{ item.description }}
              </h5>
            </b-col>
            <b-col
              cols="12"
              style="padding-left: 6px"
              v-for="(topic, indexS) in item.Topics"
              :key="`language-topic-${item.id}-${indexS}`"
            >
              <div class="list-teacher item-rda-viewlist">
                <div class="cols text-col">
                  <template
                    v-if="
                      topic.KnowledgeObject && topic.KnowledgeObject.description
                    "
                  >
                    <p class="knowledge-object-title">
                      {{
                        `${item.sort_order}.${topic.sort_order} - `
                      }}Objeto de Conhecimento:
                      {{ topic.KnowledgeObject.description }}
                    </p>
                    <p class="topic-description">
                      Conteúdo: {{ topic.description }}
                    </p>
                  </template>
                  <template v-else>
                    <p class="topic-description">
                      {{
                        `${item.sort_order}.${topic.sort_order} `
                      }}Conteúdo: {{ topic.description }}
                    </p>
                  </template>
                  <p
                    v-if="
                      topic.TopicStudents.length > 0 &&
                      topic.TopicStudents[0].updated_at
                    "
                    class="topic-description"
                    style="color: #939393"
                  >
                    <span
                      v-if="
                        topic.TopicStudents[0].editor &&
                        topic.TopicStudents[0].editor.name
                      "
                    >
                      Atualizado por
                      <strong>{{ topic.TopicStudents[0].editor.name }}</strong>
                    </span>
                    <span v-else> Atualizado </span>
                    em {{ formatDate(topic.TopicStudents[0].updated_at) }}
                  </p>
                </div>
                <div
                  class="cols"
                  v-if="
                    topic.TopicStudents[0].status === 'AN' &&
                    topic.TopicStudents[0].pendency
                  "
                >
                  <b-button
                    class="evidence-btn"
                    @click="showEvidence(topic.TopicStudents[0].pendency)"
                  >
                    Pendência
                  </b-button>
                </div>
                <div class="cols">
                  <p
                    class="tags"
                    :style="{
                      backgroundColor: setStatusColor(
                        topic.TopicStudents[0].status
                      ),
                    }"
                  >
                    {{ topic.TopicStudents[0].status }}
                  </p>
                </div>
                <div class="cols"></div>
              </div>
            </b-col>
          </b-row>
        </b-collapse>
      </div>
    </div>

    <div v-else>
      <div
        v-for="(modalityLevels, modalityName) in groupedByModalityAndLevel"
        :key="`modality-${modalityName}`"
        class="modality-group col-12"
      >
        <b-card-header
          header-tag="header"
          role="tab"
          style="
            border: 1px solid #dee2e6;
            border-radius: 10px;
            cursor: pointer;
          "
          v-b-toggle.accordion-1="
            'accordion-modality-' + getModalityId(modalityName)
          "
          class="accordion-header"
        >
          <h5 style="color: #495057">
            {{ modalityName }}
            {{
              showArtPercentage
                ? " - " + artPercentages[modalityName] + "%"
                : ""
            }}
          </h5>
        </b-card-header>

        <b-collapse
          :id="`accordion-modality-${getModalityId(modalityName)}`"
          role="tabpanel"
        >
          <div
            class="mb-2"
            style="display: flex; align-items: center; padding-left: 20px"
          >
            <span
              style="
                display: inline-block;
                width: 18px;
                height: 18px;
                background: #28a745;
                border-radius: 4px;
                margin-right: 8px;
              "
            ></span>
            <span style="font-size: 15px; color: #495057">Níveis ativos</span>
          </div>
          <div
            v-for="(levelGroup, levelName) in modalityLevels"
            :key="`level-${levelName}`"
            class="level-group"
          >
            <b-card-header
              header-tag="header"
              role="tab"
              :style="{
                border: '1px solid #dee2e6',
                borderRadius: '10px',
                cursor: 'pointer',
                borderLeft: !levelDisabled[modalityName][levelName]
                  ? '4px solid #28a745'
                  : '1px solid #dee2e6',
              }"
              v-b-toggle.accordion-2="
                'accordion-level-' + getLevelId(modalityName, levelName)
              "
              class="accordion-header"
            >
              <h5 style="color: #495057">
                {{ levelName }}
              </h5>
            </b-card-header>
            <b-collapse
              :id="`accordion-level-${getLevelId(modalityName, levelName)}`"
              role="tabpanel"
            >
              <div
                v-for="(item, index) in levelGroup"
                :key="`level-item-${index}`"
              >
                <b-row
                  class="rda-viewlist modality-content"
                  style="padding-left: 0"
                >
                  <b-col cols="12" style="padding-left: 6px">
                    <h4
                      class="title tematic-unit-title"
                      v-if="item.TematicUnit"
                    >
                      {{ item.sort_order + " - " }} Unidade
                      Temática:
                      {{ item.TematicUnit.description }}
                    </h4>
                    <h5 class="title comp-description">
                      {{
                        !item.TematicUnit
                          ? item.sort_order
                          : ""
                      }}
                      Competência:
                      {{ item.description }}
                    </h5>
                  </b-col>
                  <b-col
                    cols="12"
                    style="padding-left: 6px"
                    v-for="(topic, indexS) in item.Topics"
                    :key="`level-topic-${indexS}`"
                  >
                    <div class="list-teacher item-rda-viewlist">
                      <div class="cols text-col">
                        <p
                          class="knowledge-object-title"
                          v-if="topic.KnowledgeObject"
                        >
                          {{
                            (`${item.sort_order}.${topic.sort_order} - `) +
                            `Objeto de Conhecimento: ${topic.KnowledgeObject.description}`
                          }}
                        </p>
                        <p class="topic-description">
                          {{
                            !topic.KnowledgeObject
                              ? `${item.sort_order}.${topic.sort_order} `
                              : ""
                          }}
                          Conteúdo: {{ topic.description }}
                        </p>
                        <p
                          v-if="
                            topic.TopicStudents.length > 0 &&
                            topic.TopicStudents[0].updated_at
                          "
                          class="topic-description"
                          style="color: #939393"
                        >
                          <span
                            v-if="
                              topic.TopicStudents[0].editor &&
                              topic.TopicStudents[0].editor.name
                            "
                          >
                            Atualizado por
                            <strong>{{
                              topic.TopicStudents[0].editor.name
                            }}</strong>
                          </span>
                          <span v-else> Atualizado </span>
                          em {{ formatDate(topic.TopicStudents[0].updated_at) }}
                        </p>
                      </div>
                      <div
                        class="cols"
                        v-if="
                          topic.TopicStudents[0].status === 'AN' &&
                          topic.TopicStudents[0].pendency
                        "
                      >
                        <b-button
                          class="evidence-btn"
                          @click="showEvidence(topic.TopicStudents[0].pendency)"
                        >
                          Pendência
                        </b-button>
                      </div>
                      <div class="cols">
                        <p
                          class="tags"
                          :style="{
                            backgroundColor: setStatusColor(
                              topic.TopicStudents[0].status
                            ),
                          }"
                        >
                          {{ topic.TopicStudents[0].status }}
                        </p>
                      </div>
                      <div class="cols"></div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </div>
        </b-collapse>
      </div>
    </div>

    <b-modal
      id="modal-evidence"
      title="Pendência"
      ok-title="Ok"
      cancel-title="Fechar"
      @hidden="onModalClose"
    >
      <p>{{ pendencyText }}</p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";

export default {
  name: "StudentRDAComponent",
  props: {
    subjectSelected: {
      type: Object,
      required: true,
      validator(value) {
        return value && value.Competences && Array.isArray(value.Competences);
      },
    },
    isParentView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pendencyText: null,
      levelDisabled: {},
      levelLanguageDisabled: {},
      artPercentages: this.subjectSelected.artPercentages || {},
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/getAuthData",
    }),
    hasLanguageCompetences() {
      return this.subjectSelected.Competences.every(
        (competence) => !competence.modality && competence.details
      );
    },

    groupedLanguagesByLevel() {
      const grouped = {};

      this.subjectSelected.Competences.forEach((competence) => {
        if (competence.details && !competence.modality) {
          const level = competence.details;

          if (!grouped[level]) {
            grouped[level] = [];
            this.levelLanguageDisabled[level] = false;
          }

          const filteredTopics = this.isParentView
            ? competence.Topics.filter(
                (topic) => topic.TopicStudents[0].status !== "#"
              )
            : competence.Topics;

          if (!this.isParentView || filteredTopics.length > 0) {
            grouped[level].push({
              ...competence,
              Topics: filteredTopics,
            });
          }
        }
      });

      Object.keys(grouped).forEach((level) => {
        const allTopics = grouped[level];
        const allDisabled = allTopics.every((topic) =>
          topic.Topics.every((t) => t.TopicStudents[0].status === "#")
        );
        this.levelLanguageDisabled[level] = allDisabled;
      });

      if (this.isParentView) {
        Object.keys(grouped).forEach((level) => {
          if (grouped[level].length === 0) {
            delete grouped[level];
          }
        });
      }

      return grouped;
    },

    groupedByModalityAndLevel() {
      const grouped = {};
      let competenceSortOrderByLevel = 1;

      this.subjectSelected.Competences.forEach((competence) => {
        if (competence.modality) {
          if (!grouped[competence.modality]) {
            grouped[competence.modality] = {};
            this.levelDisabled[competence.modality] = {};
            competenceSortOrderByLevel = 1;
          }
          const level = competence.details || "Sem Nível";
          if (!grouped[competence.modality][level]) {
            grouped[competence.modality][level] = [];
            this.levelDisabled[competence.modality][level] = false;
          }

          const topicsWithSortOrder = competence.Topics.map((topic, index) => ({
            ...topic,
            sort_order: index + 1,
          }));

          const filteredTopics = this.isParentView
            ? topicsWithSortOrder.filter(
                (topic) => topic.TopicStudents[0].status !== "#"
              )
            : topicsWithSortOrder;

          if (!this.isParentView || filteredTopics.length > 0) {
            grouped[competence.modality][level].push({
              ...competence,
              Topics: filteredTopics,
              sort_order: competenceSortOrderByLevel,
            });
            competenceSortOrderByLevel++;
          } else {
            competenceSortOrderByLevel++;
          }
        }
      });

      Object.keys(grouped).forEach((modality) => {
        Object.keys(grouped[modality]).forEach((level) => {
          const allTopics = grouped[modality][level];
          const allDisabled = allTopics.every((topic) =>
            topic.Topics.every((t) => t.TopicStudents[0].status === "#")
          );
          this.levelDisabled[modality][level] = allDisabled;
        });
      });

      if (this.isParentView) {
        Object.keys(grouped).forEach((modality) => {
          Object.keys(grouped[modality]).forEach((level) => {
            if (grouped[modality][level].length === 0) {
              delete grouped[modality][level];
            }
          });

          if (Object.keys(grouped[modality]).length === 0) {
            delete grouped[modality];
          }
        });
      }

      return grouped;
    },

    competencesWithoutModality() {
      let competences = this.subjectSelected.Competences.filter(
        (competence) => !competence.modality && !competence.details
      );

      if (this.isParentView) {
        competences = competences
          .map((competence) => ({
            ...competence,
            Topics: competence.Topics.filter(
              (topic) => topic.TopicStudents[0].status !== "#"
            ),
          }))
          .filter((competence) => competence.Topics.length > 0);
      }

      return competences;
    },
    showArtPercentage() {
      const isSchoolUser =
        this.currentUser.role.includes("teacher") ||
        this.currentUser.role.includes("coordinator") ||
        this.currentUser.role.includes("admin");
      const isStudent = this.currentUser.role.includes("student");
      const isParent = this.currentUser.role.includes("parent");

      return isSchoolUser && !isStudent && !isParent;
    },
  },
  methods: {
    getLevelId(modalityName, levelName) {
      return `${this.getModalityId(modalityName)}-${levelName
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")}`;
    },

    getModalityId(modalityName) {
      return modalityName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
    },

    setStatusColor(status) {
      if (!status) {
        return "transparent";
      }
      switch (status) {
        case "EE":
          return "#b23066";
        case "AN":
          return "#ffbb00";
        case "*":
          return "#a9a9a9";
        case "#":
          return "#a9a9a9";
        default:
          return "#68c5b7";
      }
    },

    formatDate(dateString) {
      if (!dateString) {
        return "";
      }
      return moment(dateString).format("DD/MM/YYYY");
    },

    showEvidence(pendency) {
      this.pendencyText = pendency;
      this.$bvModal.show("modal-evidence");
    },

    onModalClose() {
      this.pendencyText = null;
    },

    getCompetenceIndex(competence) {
      const allCompetences = this.subjectSelected.Competences;
      const index = allCompetences.findIndex((comp) => comp === competence);
      return index + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.evidence-btn {
  border-radius: 5px;
  background-color: #68c5b7;
  color: white;
  border: none;
}

.modality-group {
  margin-bottom: 20px;

  .modality-content {
    padding-left: 20px;
    background-color: #f8f9fa;
    border-radius: 0 5px 5px 0;
    padding-top: 15px;
  }
}

.rda-viewlist {
  margin-bottom: 0px;

  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #36b67d;
    margin-bottom: 12px;
  }

  .item-rda-viewlist {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    .cols {
      .tags {
        min-width: 40px;
      }
    }

    .text-col {
      flex: 1;
    }
  }

  .competence-details {
    color: #b23066;
    font-weight: 700;
  }

  .tematic-unit-title {
    color: #36b67d;
    font-weight: 600;
    font-size: 18px;
  }

  .comp-description {
    padding-right: 40px !important;
    font-size: 16px !important;
    line-height: 20px;
  }

  .knowledge-object-title {
    font-weight: 600;
    font-size: 16px;
  }

  .topic-description {
    font-size: 14px;
    line-height: 18px;
  }
}

.tags {
  padding: 4px 8px;
  border-radius: 4px;
  color: white;
  font-weight: bold;
  text-align: center;
  min-width: 40px;
}

.level-group {
  margin: 15px 0;
  padding-left: 20px;

  .modality-content {
    background-color: #f8f9fa;
  }
}

::v-deep .card-header {
  background-color: #f7f7f7;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);

  &.accordion-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.15s;

    &:hover {
      background-color: #e9ecef;
    }

    &:after {
      background: #868e96;
      display: block;
      content: "";
      -webkit-mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
        no-repeat 50% 50%;
      mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
        no-repeat 50% 50%;
      -webkit-mask-size: cover;
      mask-size: cover;
      width: 20px;
      height: 20px;
      transition: all 0.15s;
      transform: rotate(0deg);
      flex-shrink: 0;
    }

    &[aria-expanded="true"]:after {
      transform: rotate(180deg);
    }
  }

  h5 {
    margin: 0;
    color: #495057;
    font-weight: 600;
    pointer-events: none;

    &:hover {
      color: #495057;
    }
  }
}

::v-deep .collapse {
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 10px;
  padding: 1rem;
}
</style>
